import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/AuthContext";
import Landing from "./pages/Landing";
import ItineraryPage from "./pages/Itinerary";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AuthCallback from "./pages/AuthCallback";
import Create from "./pages/Create";
import SpotPage from "./pages/SpotPage";
import Discover from "./pages/Discover";
import Guide from "./pages/Guide";
import { Toaster } from "./components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // Synchronous detection of OAuth callback (URL fragment) — must run BEFORE other auth checks
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/create" element={<Create />} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/guide" element={<Guide />} />
      <Route path="/itinerary/:id" element={<ItineraryPage />} />
      <Route path="/spot/:itineraryId/:spotId" element={<SpotPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
